module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BEGINNINGS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1500–1900")])]), _vm._v(" "), _c('p', {
    staticClass: "sered",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("A Series Edited by Edward Gray, Stephen Mihm, and Mark Peterson")]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ALSO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SERIES:")])]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_c('i', [_vm._v("Urban Dreams, Rural Commonwealth: The Rise of Plantation Society in the Chesapeake")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Paul Musselwhite")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Building a Revolutionary State: The Legal Transformation of New York, 1776–1783")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Howard Pashman")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Sovereign of the Market: The Money Question in Early America")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Jeffrey Sklansky")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("National Duties: Custom Houses and the Making of the American State")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Gautham Rao")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Liberty Power: Antislavery Third Parties and the Transformation of American Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Corey M. Brooks")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Making of Tocqueville’s America: Law and Association in the Early United States")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Kevin Butterfield")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Planters, Merchants, and Slaves: Plantation Societies in British America, 1650–1820")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Trevor Burnard")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Riotous Flesh: Women, Physiology, and the Solitary Vice in Nineteenth-Century America")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by April R. Haynes")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Holy Nation: The Transatlantic Quaker Ministry in an Age of Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Sarah Crabtree")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("A Hercules in the Cradle: War, Money, and the American State, 1783–1867")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Max M. Edling")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Frontier Seaport: Detroit’s Transformation into an Atlantic Entrepôt")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Catherine Cangany")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Beyond Redemption: Race, Violence, and the American South after the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Carole Emberton")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Republic Afloat: Law, Honor, and Citizenship in Maritime America")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Matthew Taylor Raffety")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Conceived in Doubt: Religion and Politics in the New American Nation")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Amanda Porterfield")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a3c074","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hart-0003.vue
// module id = 60
// module chunks = 0